import JobsAppHero from '../../components/JobsAppHero';
import LogosBanner from '../../components/LogosBanner';

import AccessibilitySection from './AccessibilitySection';
import CommunitiesSection from './CommunitiesSection';
import DEISection from './DEISection';
import SustainabilitySection from './SustainabilitySection';

const ESGPage = () => (
  <div>
    <JobsAppHero bannerType="esg" />
    <section className="grid__container">
      <div className="grid__row">
        <div className="grid__column--padded grid__column--tablet-12">
          <h1>Making a Positive Impact</h1>
          <p>
            As we continue to grow at scale, we have a responsibility to ensure
            our business has a positive impact on our people and communities,
            acknowledging that we must take action when it comes to climate
            change and the impact our business has on the environment.
            We&apos;re working to bring greater diversity to the tech sector,
            striving to ensure we&apos;re as inclusive and accessible as
            possible, taking ownership for our carbon footprint and supporting
            initiatives to heighten the positive effects of travel. Our areas of
            focus (Accessibility, Communities, DEI and Sustainability) have been
            a part of Skyscanner for many years now, and we&apos;re proud of our
            achievements.
          </p>
        </div>
      </div>
      <hr aria-hidden="true" />
    </section>
    <DEISection />
    <SustainabilitySection />
    <AccessibilitySection />
    <CommunitiesSection />
    <section className="grid__container content-block">
      <p style={{ fontStyle: 'italic' }}>
        Skyscanner is an equal opportunities employer. We&apos;re committed to
        ensuring our application and recruitment processes are inclusive and
        accessible to everyone. If you require any reasonable adjustments or
        accommodations for interviews, please let us know. If you&apos;d like
        more information on any of our policies, such as hybrid working or
        Parental Leave policies (typically we pay a minimum of 24 weeks birth
        parent/maternity leave globally), our recruitment team can provide more
        information on these.
      </p>
    </section>
    <LogosBanner />
  </div>
);

export default ESGPage;
